export type TipoCampo =
    | 'string'
    | 'number'
    | 'integer'
    | 'boolean'
    | 'date'
    | 'datetime'
    | 'select';


export const TIPOS_CAMPO = [
    { value: 'string', label: 'Texto' },
    { value: 'number', label: 'Número (decimal)' },
    { value: 'integer', label: 'Número inteiro' },
    { value: 'boolean', label: 'Sim / Não' },
    { value: 'date', label: 'Data' },
    { value: 'datetime', label: 'Data e hora' },
    { value: 'select', label: 'Lista de opções' },
]

export const TIPOS_MOTIVO = [
    { value: 'venda', label: 'Venda' },
    { value: 'consumo_proprio', label: 'Consumo próprio' },
    { value: 'aplicacao_campo', label: 'Aplicação em campo' },
    { value: 'perda', label: 'Perda' },
    { value: 'doacao', label: 'Doação' },
    { value: 'transferencia', label: 'Transferência' },
    { value: 'outro', label: 'Outro' },
]


export type TipoArmazem =
    | 'produtos_agricolas'
    | 'insumos'
    | 'equipamentos'
    | 'outros';

export const TipoArmazem_array = [
    'produtos_agricolas',
    'insumos',
    'equipamentos',
    'outros',
]

export interface CampoSchema {

    nome: string;
    tipo: TipoCampo;
    obrigatorio: boolean;
    label?: string;
    descricao?: string;
    opcoes?: string[];
    valor_padrao?: any;
    validacao?: {
        min?: number;
        max?: number;
        pattern?: string;
    }

}
export interface CampoSchema_aux {
    campos: [
        nome: string,
        tipo: TipoCampo,
        obrigatorio: boolean,
        label?: string,
        descricao?: string,
        opcoes?: string[],
        valor_padrao?: any,
        validacao?: {
            min?: number;
            max?: number;
            pattern?: string;
        }
    ]
}

export interface ValidacaoConfig {
    controlar_stock: boolean;
    permitir_stock_negativo: boolean;
    alerta_stock_minimo: boolean;
    stock_minimo_default: number;
}

export interface Icampovariavel {
    [key: string]: string | boolean | number | null;
}
export interface ArmazemEntrada {
    id_entrada: number;
    id_armazem: number;
    data_entrada: string;
    dados: Icampovariavel[];
    quantidade_entrada: number;
    unidade: string;
    documento_ref: string;
    observacoes: string;
    registado_por: string;
    last_update: string;
    create_date: string;
    uuid: string;
}

export interface ArmazemSaida {
    id_saida: number;
    id_armazem: number;
    data_saida: string;
    dados: Icampovariavel[];
    quantidade_saida: number;
    unidade: string;
    motivo: string;
    destino: string;
    documento_ref: string;
    observacoes: string;
    registado_por: string;
    last_update: string;
    create_date: string;
    uuid: string;
}

export interface Icampos {
    campos: CampoSchema[]
}

export interface IArmazem {
    id_armazem: number;
    id_agri: number;
    nome: string;
    descricao?: string;
    tipo_armazem: TipoArmazem;
    localizacao?: string;
    schema_custom: Icampos;
    validacao_config: ValidacaoConfig;
    activo: boolean;
    entradas: number;
    saidas: number;
    last_update: string;
    create_date: string;
    uuid: string;
}

